import { render, staticRenderFns } from "./question_h5.vue?vue&type=template&id=56d9d232&scoped=true"
import script from "./question_h5.vue?vue&type=script&lang=js"
export * from "./question_h5.vue?vue&type=script&lang=js"
import style0 from "./question_h5.vue?vue&type=style&index=0&id=56d9d232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d9d232",
  null
  
)

export default component.exports